module.exports = __webpack_public_path__ + "static/media/feature_invoice.77c280be.png";